export const GET_ESITO_INVIO_EMAIL_TABLE_DATA = 'GET_ESITO_INVIO_EMAIL_TABLE_DATA';
export const GET_ESITO_INVIO_EMAIL_FILTER_OPTIONS = 'GET_ESITO_INVIO_EMAIL_FILTER_OPTIONS';
export const GET_PARAMETRI_ESIM_TABLE_DATA = 'GET_PARAMETRI_ESIM_TABLE_DATA';
export const GET_PARAMETRI_ESIM_FILTER_OPTIONS = 'GET_PARAMETRI_ESIM_FILTER_OPTIONS';
export const IMPORT_DISTRIBUZIONE_ESIM = "IMPORT_DISTRIBUZIONE_ESIM";
export const IMPORT_DISTRIBUZIONE_ESIM_SOSTITUTIVE = "IMPORT_DISTRIBUZIONE_ESIM_SOSTITUTIVE";
export const DISTRIBUZIONE_ESIM = "DISTRIBUZIONE_ESIM";
export const EXPORT_DISTRIBUZIONE_ESIM_CSV = "EXPORT_DISTRIBUZIONE_ESIM_CSV";
export const GET_ESITO_CAMBIO_FORMATO_TABLE_DATA = 'GET_ESITO_CAMBIO_FORMATO_TABLE_DATA';
export const GET_ESITO_CAMBIO_FORMATO_FILTER_OPTIONS = 'GET_ESITO_CAMBIO_FORMATO_FILTER_OPTIONS';
export const CAMBIO_FORMATO_DISTRIBUZIONE = "CAMBIO_FORMATO_DISTRIBUZIONE"
export const CAMBIO_FORMATO = "CAMBIO_FORMATO"
export const GET_SOSTITUTIVE_LIST = "GET_SOSTITUTIVE_LIST"
export const EXPORT_SOSTITUTIVE_LIST_CSV = "EXPORT_SOSTITUTIVE_LIST_CSV"
export const IMPORT_CAMBIO_FORMATO_DISTRIBUZIONE = "IMPORT_CAMBIO_FORMATO_DISTRIBUZIONE";
export const EXPORT_CAMBIO_FORMATO_DISTRIBUZIONE = "EXPORT_CAMBIO_FORMATO_DISTRIBUZIONE";
export const IMPORT_CAMBIO_FORMATO_CSV= "IMPORT_CAMBIO_FORMATO_CSV";
export const EXPORT_CAMBIO_FORMATO_CSV = "EXPORT_CAMBIO_FORMATO_CSV";
export const EXPORT_MASSIVE_TAGS_CSV = "EXPORT_MASSIVE_TAGS_CSV";
export const IMPORT_MASSIVE_TAGS_CSV = "IMPORT_MASSIVE_TAGS_CSV";
export const INSERT_BATCH_ASSOCIATE_TAGS = "INSERT_BATCH_ASSOCIATE_TAGS";
export const STORE_RADIO_VALUE = "STORE_RADIO_VALUE";
